/**
 * Cache wrapper for the Dropoffs list. TtlCache (15-min, single "all" entry, in-flight coalescing)
 * around `API.Data.Dropoffs.get.all()`. Dropoff locations are global reference data that change
 * rarely, so a shared cache spares every consumer (and every remount) a fresh fetch.
 */

import { Dropoff } from "@domain/CRM/dropoff";
import { TtlCache } from "../../../cache/ttlCache";
import { API } from "../../../api";

const LIST_TTL_MS = 15 * 60 * 1000;
const LIST_KEY = "all" as const;

class CachedDropoffsList {
	private cache = new TtlCache<typeof LIST_KEY, Dropoff[]>(LIST_TTL_MS, () => API.Data.Dropoffs.get.all());

	/** Synchronous TTL cache hit, or null if missing/expired. */
	public peek(): Dropoff[] | null {
		return this.cache.peek(LIST_KEY);
	}

	public get(): Promise<Dropoff[]> {
		return this.cache.get(LIST_KEY);
	}

	public clear(): void {
		this.cache.clear();
	}
}

export class CachedDropoffsAPI {
	public list = new CachedDropoffsList();
}
